import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../shared/TailwindComponents/Button";
import Textarea from "../shared/TailwindComponents/Textarea";

interface EditTextModalProps {
  title: string;
  initialValue: string;
  onConfirm: (value: string) => void;
  onCancel: () => void;
  rows?: number;
  placeholder?: string;
}

const EditTextModal: React.FC<EditTextModalProps> = ({
  title,
  initialValue,
  onConfirm,
  onCancel,
  rows = 6,
  placeholder = '',
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue);

  const handleSave = () => {
    onConfirm(value);
  };

  const handleClear = () => {
    setValue('');
  };

  return (
    <div className="bg-white dark:bg-gray-800 space-y-4 md:w-[600px] w-[400px]">
        <div className="px-4">
      <Textarea
              value={value}
              onChange={(e) => setValue(e.target.value)}
              rows={rows}
              placeholder={placeholder} 
              h="h-[200px]"
              id={""} 
              label={""}      />
              </div>
        <div className="mt-6 pt-6 border-1 border-t border-gray-300 flex justify-end gap-2 px-4">
        <Button variant="neutral" size="small" onClick={onCancel}>
          {t('Cancel')}
        </Button>
        <Button variant="outline" size="small" onClick={handleClear}>
          {t('Clear')}
        </Button>
        <Button variant="primary" size="small" onClick={handleSave}>
          {t('Save')}
        </Button>
      </div>
    </div>
  );
};

export default EditTextModal;